<div class="participant-container">
  <div *ngIf="isRecipient" class="participant-header">
    <mat-icon class="icon" svgIcon="human-{{ recipient?.gender === 'M' ? 'male' : 'female' }}"></mat-icon>
    <div class="participant-details">
      <p class="name">
        <span
          >{{ recipient?.firstName }} {{ recipient?.lastName }} <span *ngIf="recipient?.historical" class="archived-label">(archived patient)</span>
          <p class="type">Recipient</p></span
        >
      </p>

      <p *ngIf="recipient?.enisNumber">
        <label>ET Number</label>
        {{ recipient?.enisNumber }}
      </p>
      <p *ngIf="recipient?.priority">
        <label>Priority</label>
        Yes
      </p>

      <p *ngIf="recipient?.center">
        <label>Center</label>
        {{ recipient?.center?.name }}
      </p>
      <p>
        <label>Date of birth</label>
        {{ recipient?.dob | date: "d MMM y" }}
        <span class="age">({{ age }} years old)</span>
      </p>

      <p *ngIf="recipient?.urgency && recipient?.abo">
        <label>Blood group / Ki-Urgency</label>
        {{ recipient?.abo }} / {{ recipient?.urgency }}
      </p>
      <p *ngIf="recipient?.abo && !recipient?.urgency">
        <label>Blood group</label>
        {{ recipient?.abo }}
      </p>
      <p *ngIf="recipient?.abPhenotype">
        <label>HLA Class I</label>
        {{ recipient?.abPhenotype }}
      </p>
      <p *ngIf="recipient?.drPhenotype">
        <label>HLA Class II</label>
        {{ recipient?.drPhenotype }}
      </p>
      <p *ngIf="recipient?.dateFirstDialysis">
        <label>Date first dialysis</label>
        {{ recipient?.dateFirstDialysis | date: "d MMM y" }}
      </p>
      <p *ngIf="recipient?.unacceptables">
        <label>Unacceptables</label>
        {{ recipient?.unacceptables }}
      </p>
      <p *ngIf="recipient?.dateScreening">
        <label>Last screening</label>
        {{ recipient?.dateScreening | date: "d MMM y" }}
      </p>
      <p *ngIf="recipient?.primaryDiagnosis">
        <label>Primary diagnosis</label>
        {{ recipient?.primaryDiagnosis }}
      </p>

      <p *ngIf="recipient?.previousPRA">
        <label>Returned waiting days</label>
        {{ recipient?.previousPRA }}
      </p>
      <p *ngIf="recipient?.virtualPRA !== null && recipient?.virtualPRA !== undefined">
        <label>Current vPRA</label>
        {{ recipient?.virtualPRA }}%
      </p>
      <p *ngIf="(recipient?.virtualPRA === null || recipient?.virtualPRA === undefined) && recipient?.unacceptables === ''">
        <label>Current vPRA</label>
        0%
      </p>

      <!-- Privileges Section -->
      <p *ngIf="age < 18">
        <label><span class="privilege-indicator"></span>Children Extra Wait Time</label>
        Yes
      </p>

      <p *ngIf="recipient?.maxDonorAge">
        <label><span class="privilege-indicator"></span>Max Donor Age</label>
        {{ recipient?.maxDonorAge }}
      </p>

      <p *ngIf="recipient?.maxMismatches">
        <label><span class="privilege-indicator"></span>Max mismatches</label>
        {{ recipient?.maxMismatches }}
      </p>
      <p *ngIf="recipient?.maxMmA">
        <label><span class="privilege-indicator"></span>Max mm A</label>
        {{ recipient?.maxMmA }}
      </p>
      <p *ngIf="recipient?.maxMmB">
        <label><span class="privilege-indicator"></span>Max mm B</label>
        {{ recipient?.maxMmB }}
      </p>
      <p *ngIf="recipient?.maxMmDR">
        <label><span class="privilege-indicator"></span>Max mm DR</label>
        {{ recipient?.maxMmDR }}
      </p>
      <p *ngIf="recipient?.acceptableBloodTypes">
        <label><span class="privilege-indicator"></span>Acceptable Bloodtypes</label>
        {{ formattedAcceptableBloodTypes }}
      </p>
      <p *ngIf="recipient?.acceptableHla">
        <label><span class="privilege-indicator"></span>Delisted Unacceptables</label>
        {{ recipient?.acceptableHla }}
      </p>
      <p *ngIf="recipient?.extraWaitTime">
        <label><span class="privilege-indicator"></span>Extra wait time</label>
        {{ recipient?.extraWaitTime }}
      </p>
      <p *ngIf="recipient?.lowMfi1">
        <label><span class="privilege-indicator"></span>Low MFI unacceptables class 1 (A/B)</label>
        {{ recipient?.lowMfi1 }}
      </p>
      <p *ngIf="recipient?.lowMfi2">
        <label><span class="privilege-indicator"></span>Low MFI unacceptables class 2 (DR/DQ)</label>
        {{ recipient?.lowMfi2 }}
      </p>

      <p *ngIf="recipient?.lastUpdate">
        <label>Last updated</label>
        {{ recipient?.lastUpdate | date: "d MMM y, HH:mm:ss" }}
      </p>
    </div>
  </div>

  <!-- Inactive recipient banner -->
  <div class="inactive-reason" *ngIf="isRecipientInactive">
    Inactive recipient{{ recipientInactiveReason ? ' with reason: ' + recipientInactiveReason : '' }}
  </div>

  <!-- Donor-specific template -->
  <div *ngIf="!isRecipient && donor" class="participant-header">
    <mat-icon class="icon" svgIcon="human-{{ donor.gender === 'M' ? 'male' : 'female' }}"></mat-icon>
    <div class="participant-details">
      <p class="name">
        <span
          >{{ donor.firstName }} {{ donor.lastName }} <span *ngIf="donor?.historical" class="archived-label">(archived patient)</span>
          <p class="type">Donor</p>
        </span>
      </p>

      <p *ngIf="donor.enisNumber">
        <label>ET Number</label>
        {{ donor.enisNumber }}
      </p>
      <p *ngIf="donor?.altruist">
        <label>Altruist</label>
        Yes
      </p>
      <p *ngIf="donor?.center">
        <label>Center</label>
        {{ donor.center.name }}
      </p>
      <p>
        <label>Date of birth</label>
        {{ donor.dob | date: "d MMM y" }}
        <span class="age">({{ age }} years old)</span>
      </p>

      <p *ngIf="donor?.abo">
        <label>Blood group</label>
        {{ donor.abo }}
      </p>
      <p *ngIf="donorHlaClassI">
        <label>HLA Class I</label>
        {{ donorHlaClassI }}
      </p>
      <p *ngIf="donorHlaClassII">
        <label>HLA Class II</label>
        {{ donorHlaClassII }}
      </p>

      <p *ngIf="donor?.limitedToCenter?.length">
        <label><span class="privilege-indicator"></span>Limited to Centers:</label>
        <span>
          <ng-container *ngFor="let center of donor?.limitedToCenter; let isLast = last"> {{ center.name }}<span *ngIf="!isLast">, </span> </ng-container>
        </span>
      </p>

      <p *ngIf="donor?.lastUpdate">
        <label>Last updated</label>
        {{ donor.lastUpdate | date: "d MMM y, HH:mm:ss" }}
      </p>
    </div>
  </div>

  <!-- Inactive donor banner -->
  <div class="inactive-reason" *ngIf="isDonorInactive && isDonorAltruist">
    Inactive altruistic donor{{ donorInactiveReason ? ' with reason: ' + donorInactiveReason : '' }}
  </div>
  <div class="inactive-reason" *ngIf="isDonorInactive && !isDonorAltruist">
    Inactive donor{{ donorInactiveReason ? ' with reason: ' + donorInactiveReason : '' }}
  </div>

  <!-- Show locked message instead of action buttons when participant is locked or selected for transplantation -->
  <div class="locked-message" *ngIf="isParticipantLocked">
    <mat-icon>lock</mat-icon>
    <span>{{ lockMessage }}</span>
  </div>

  <!-- Action buttons (only show when not locked and not historical) -->
  <mat-action-row class="buttonsrow" *ngIf="!isParticipantLocked && recipient && !recipient.historical">
    <button *ngIf="canRemoveParticipant && recipient.firstName !== '*****' && canCenterUserArchiveParticipant(recipient)" mat-button class="warn-button" (click)="removeRecipient(recipient)">Archive recipient</button>
    <button *ngIf="canEditParticipant && recipient.firstName !== '*****' && !recipient.postmortumwaitlist" mat-button class="custom-button" (click)="requestPriority(recipient)">Committee request</button>
    <button *ngIf="canEditParticipant && recipient.firstName !== '*****' && canCenterUserEditParticipant(recipient)" mat-button class="custom-button" (click)="editRecipient(recipient)" color="primary">Edit recipient</button>
  </mat-action-row>

  <mat-action-row class="buttonsrow" *ngIf="!isParticipantLocked && donor && !donor.historical">
    <button *ngIf="canRemoveParticipant && donor.firstName !== '*****' && canCenterUserArchiveParticipant(donor)" mat-button class="warn-button" (click)="removeDonor(donor)">Archive donor</button>
    <button *ngIf="canEditParticipant && donor.firstName !== '*****' && canCenterUserEditParticipant(donor)" mat-button class="custom-button" (click)="editDonor(donor)" color="primary">Edit donor</button>
  </mat-action-row>

  <!-- Timeline History Section -->
  <div class="history-container">
    <h3>History</h3>
    <div *ngFor="let history of timelineHistory" class="history-item">
      <p>
        <label>Action:</label><strong>{{ history.action | titlecase }} </strong>
      </p>
      <p><label>Date:</label> {{ history.dateCreated | date: "d MMM y, HH:mm:ss" }}</p>
      <div *ngIf="history.changes && history.changes.length > 0">
        <label>Changes:</label>
        <ul>
          <ng-container *ngFor="let change of history.changes">
            <li *ngIf="change.field !== 'lastUpdate'">
              <strong>{{ change.field }}:</strong>
              <ng-container *ngIf="change.field !== 'center' && change.field !== 'limitedToCenter'"> {{ change.oldValue }} → {{ change.newValue }} </ng-container>
              <ng-container *ngIf="change.field == 'limitedToCenter' && change.oldValue && change.newValue">
                {{ parseCenterName(change.oldValue) }} → {{ parseCenterName(change.newValue) }}
              </ng-container>
              <ng-container *ngIf="change.field == 'center' && change.oldValue && change.newValue"> {{ parseCenterName(change.oldValue) }} → {{ parseCenterName(change.newValue) }} </ng-container>
            </li>
          </ng-container>
        </ul>
      </div>

      <p><label>Performed By:</label> {{ history.actionByUser }}</p>
    </div>
  </div>
  <div class="spacer"></div>
</div>
